import React, { useEffect, useState } from "react";
import axios from "axios";
import { Form, Row, Col, Button, Accordion } from "react-bootstrap";
import { Base_URL } from "../url";
import { useAuth } from "../Context/AuthContext";
import { toast } from "react-toastify";

const ItemForm = () => {
  const { token } = useAuth();
  const [items, setItems] = useState([]);
  const { user } = useAuth();
  const [form, setForm] = useState({
    itemCode: "",
    batchId: "",
    mfgDate: "",
    expDate: "",
    mrpInclGst: "",
    ptrExclGst: "",
  });

  // Fetch items for dropdown
  useEffect(() => {
    const fetchItems = async () => {
      try {
        const res = await axios.get(`${Base_URL}/Item/ItemGetData`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
        setItems(res.data || []);
      } catch (err) {
        console.error("Error fetching items:", err);
      }
    };

    fetchItems();
  }, [token]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const payload = {
      itemCode: form.itemCode,
      batchId: form.batchId,
      mfgDate: form.mfgDate,
      expDate: form.expDate,
      mrpInclGst: form.mrpInclGst,
      ptrExclGst: form.ptrExclGst,
      organisationId: user?.organisationId,
    };

    const res = await axios.post(`${Base_URL}/BatchMaster/CreateBatch`, payload);

    if (res.data) {
      toast.success(`${res.data} Batch created successfully`);
    } else {
      toast.error("Error creating Batch");
    }
  };

  return (
    <div className="container form-fields">

      <div className="fields-title">
        Item Entry
      </div>

      <Form className="fields-form" onSubmit={handleSubmit}>

        <Accordion defaultActiveKey="0">

          <Accordion.Item eventKey="0">

            {/* <Accordion.Header>
              <div className="employee-header">
                <div className="employee-header-left">
                  <div className="details-icon-card">
                    📦
                  </div>
                  <div className="details-header-text">
                    Batch Details
                  </div>
                </div>

                <div className="employee-header-summary">
                  Enter batch information for the selected item
                </div>
              </div>
            </Accordion.Header> */}

            <Accordion.Body>

              <Row className="g-3">

                {/* Item Dropdown */}
                <Col md={6}>
                  <Form.Group controlId="itemCode">
                    <Form.Label>Item</Form.Label>
                    <Form.Select
                      name="itemCode"
                      value={form.itemCode}
                      onChange={handleChange}
                      required
                    >
                      <option value="">-- Select Item --</option>
                      {items.map((item) => (
                        <option key={item.itemCode} value={item.itemCode}>
                          {item.itemCode} - {item.itemName}
                        </option>
                      ))}
                    </Form.Select>
                  </Form.Group>
                </Col>

                {/* Batch Id */}
                <Col md={6}>
                  <Form.Group controlId="batchId">
                    <Form.Label>Batch ID</Form.Label>
                    <Form.Control
                      type="text"
                      name="batchId"
                      value={form.batchId}
                      onChange={handleChange}
                      required
                    />
                  </Form.Group>
                </Col>

                {/* Mfg Date */}
                <Col md={6}>
                  <Form.Group controlId="mfgDate">
                    <Form.Label>Mfg Date</Form.Label>
                    <Form.Control
                      type="date"
                      name="mfgDate"
                      value={form.mfgDate}
                      onChange={handleChange}
                      required
                    />
                  </Form.Group>
                </Col>

                {/* Exp Date */}
                <Col md={6}>
                  <Form.Group controlId="expDate">
                    <Form.Label>Exp Date</Form.Label>
                    <Form.Control
                      type="date"
                      name="expDate"
                      value={form.expDate}
                      onChange={handleChange}
                      required
                    />
                  </Form.Group>
                </Col>

                {/* MRP */}
                <Col md={6}>
                  <Form.Group controlId="mrpInclGst">
                    <Form.Label>MRP (Including GST)</Form.Label>
                    <Form.Control
                      type="number"
                      name="mrpInclGst"
                      value={form.mrpInclGst}
                      onChange={handleChange}
                      required
                    />
                  </Form.Group>
                </Col>

                {/* PTR */}
                <Col md={6}>
                  <Form.Group controlId="ptrExclGst">
                    <Form.Label>PTR (Excluding GST)</Form.Label>
                    <Form.Control
                      type="number"
                      name="ptrExclGst"
                      value={form.ptrExclGst}
                      onChange={handleChange}
                      required
                    />
                  </Form.Group>
                </Col>

              </Row>

            </Accordion.Body>

          </Accordion.Item>

        </Accordion>

        <div className="fields-btn-container mt-3">
          <Button variant="primary" type="submit" className="fields-submit">
            Submit
          </Button>
        </div>

      </Form>

    </div>
  );
};

export default ItemForm;